<template>
  <div>
    <!-- <div style="height: 30px">
        <div class="panelText pro" @click="twinkle_start(1)">
          {{ panelArr[0] }}<em v-if="cursor && keyBoardType === 1">|</em>
        </div>
        <div class="panelText text" @click="twinkle_start(2)">
          {{ panelArr[1] }}<em v-if="cursor && keyBoardType === 2">|</em>
        </div>
      </div> -->

    <!-- <el-input style="display: none" v-model="plateStr" /> -->
    <el-popover
      v-model="panelShow"
      placement="bottom"
      width="420"
      trigger="manual"
    >
      <div
        class="vehicle-panel"
        style="height: 290px"
        :style="{
          left: positionData.left + 'px',
          top: positionData.bottom + 'px',
        }"
      >
        <div class="vehicle-panel-row row-btn">
          <div class="top-button" @click="down">取消</div>
          <div class="top-button finish" @click="vehicleTap('ok')">完成</div>
        </div>
        <!--省份简写键盘-->
        <section v-if="keyBoardType === 1">
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button"
              v-for="(item, idx) in keyVehicle1"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button"
              v-for="(item, idx) in keyVehicle2"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button"
              v-for="(item, idx) in keyVehicle3"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row-last">
            <div class="vehicle-panel-row-button2" @click="changKeyBoard(2)">
              ABC
            </div>
            <div class="vehicle-panel-row-button" @click="vehicleTap('临')">临</div>
            <!--          <div class="vehicle-panel-row-button vehicle-panel-row-button-last" v-for="(item, idx) in keyVehicle4" @click="vehicleTap(item)" :key="idx">{{item}}</div>-->
            <div
              class="vehicle-panel-row-button3 vehicle-panel-row-button-img"
              @click="vehicleTap('delete')"
            >
              <!-- data-value="delete"-->
              <span class="vehicle-en-button-delete">
                <i class="el-icon-close"></i>
              </span>
            </div>
          </div>
        </section>
        <!--英文键盘  -->
        <section v-else>
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button vehicle-panel-row-button-number"
              v-for="(item, idx) in keyNumber"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button"
              v-for="(item, idx) in keyEnInput1"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button"
              v-for="(item, idx) in keyEnInput2"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row">
            <div
              class="vehicle-panel-row-button"
              v-for="(item, idx) in keyEnInput3"
              @click="vehicleTap(item)"
              :key="idx"
            >
              {{ item }}
            </div>
          </div>
          <div class="vehicle-panel-row-last engLast">
            <div class="vehicle-panel-row-button2" @click="changKeyBoard(1)">
              省份
            </div>
            <div class="mod04">
              <div class="mod04-row">
                <div
                  class="vehicle-panel-row-button vehicle-panel-row-button"
                  v-for="(item, idx) in keyVehicle4"
                  @click="vehicleTap(item)"
                  :key="idx"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div
              class="vehicle-panel-row-button3 vehicle-panel-row-button-img"
              @click="vehicleTap('delete')"
            >
              <!-- data-value="delete"-->
              <span class="vehicle-en-button-delete">
                <i class="el-icon-close"></i>
              </span>
            </div>
          </div>
        </section>
      </div>
      <!-- <el-button slot="reference">hover 激活</el-button> -->
      <span
        slot="reference"
        style="
          display: inline-block;
          width: auto;
          height: auto;
          position: relative;
        "
        ref="plate"
      >
        <slot>
          <!-- <div style="height: 30px">
        <div class="panelText pro" @click="twinkle_start(1)">
          {{ panelArr[0] }}<em v-if="cursor && keyBoardType === 1">|</em>
        </div>
        <div class="panelText text" @click="twinkle_start(2)">
          {{ panelArr[1] }}<em v-if="cursor && keyBoardType === 2">|</em>
        </div>
      </div> -->
        </slot>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: String,
    },
  },
  mounted() {
    // console.log(this.$refs.plate.getBoundingClientRect());
    // let pData = this.$refs.plate.getBoundingClientRect();
    // this.positionData.left = pData.bottom;
    // this.positionData.top = pData.left;
  },
  data() {
    return {
      formInline: {
        user: "",
        region: "",
      },
      keyVehicle1: "京津沪冀豫云陕辽浙赣",
      keyVehicle2: "黑湘皖鲁新苏鄂桂甘晋",
      keyVehicle3: "蒙吉闽贵粤川青琼宁渝",
      keyNumber: "1234567890",
      keyEnInput1: "QWERTYUIOP",
      keyEnInput2: "ASDFGHJKLZ",
      keyEnInput3: "XCVBNM藏学警军",
      keyVehicle4: "港澳领",
      cursor: false,
      time: null,
      panelShow: false,
      panelMore: false,
      keyBoardType: 1,
      panelArr: ["", ""],
      plateStr: this.data,
      positionData: {
        left: 0,
        top: 0,
      },
    };
  },
  watch: {
    visible(v) {
      this.panelShow = v;
      //   if (!v) {
      //     this.panelArr = ["", ""];
      //   }
    },
    data: function (newV) {
      this.plateStr = newV;
    },
  },
  methods: {
    calcPostion() {
      let pData = this.$refs.plate.getBoundingClientRect();
      this.positionData.left = 0;
      this.positionData.top = pData.bottom + 10;
      console.log(this.positionData);
    },
    changKeyBoard(e) {
      this.keyBoardType = e;
    },
    twinkle_start() {
      //   this.keyBoardType = n;
      // this.panelArr[n - 1] = '';
      this.calcPostion();
      if (this.panelShow) {
        this.twinkle_stop();
      } else {
        this.panelShow = true;
        this.twinkle_cursor();
      }
    },
    twinkle_stop() {
      this.cursor = true;
    },
    twinkle_cursor() {
      this.cursor = !this.cursor;
      if (this.panelShow) {
        let time = setTimeout(() => {
          this.twinkle_cursor();
        }, 500);
        this.time = time;
      } else {
        clearTimeout(this.time);
      }
    },
    vehicleTap(val) {
      switch (val) {
        case "delete":
          this.handleDelete();
          break;
        case "ok":
          this.handleOk();
          break;
        default:
          this.handleChange(val);
      }
    },
    handleOk() {
      function isVehicleNumber(vehicleNumber) {
        const newReg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DABCEFGHJK]([A-HJ-NP-Z0-9])[0-9]{4})|([A-HJ-NP-Z][A-HJ-NP-Z0-9][0-9]{5}))|(粤A(P[0-5]|(HN|HP|HQ))[0-9]{4}))$/
        const oldReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]$/

        if (vehicleNumber.length === 7) {
          return oldReg.test(vehicleNumber);
        } else if (vehicleNumber.length === 8) {
          return newReg.test(vehicleNumber); // 京AA12345
        } else {
          return false;
        }
      }
      isVehicleNumber(this.plateStr);
      let Reg = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DABCEFGHJK])|([DABCEFGHJKY]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|(粤A(P[0-5]|(HN|HP|HQ))[0-9]{4})|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z]{2}[A-HJ-NP-Z0-9][0-9]{4}))$/;

      //   let panelText = this.panelArr.join("");
      if (Reg.test(this.plateStr)) {
        this.panelShow = false;
        this.$emit("ok", {value: this.plateStr, key: 'plateNumber'});
      } else {
        this.$message({
          message: "车牌格式输入有误",
          type: "warning",
        });
      }
    },
    handleDelete() {
      let str = this.plateStr;
      console.log(str);
      str = str.slice(0, str.length - 1);
      this.plateStr = str;
      if (this.plateStr.length === 0) this.keyBoardType = 1;
      this.updateData();
    },
    handleChange(e) {
      if (this.keyBoardType === 1) {
        this.keyBoardType = 2;
      }
      if (this.plateStr.length <= 8) {
        this.plateStr += e;
      }
      this.updateData();
      // this.$emit('ok', this.panelArr.join(''));
    },
    updateData() {
      this.$emit("update:data", this.plateStr);
    },
    down() {
      this.panelShow = false;
      this.plateStr = "";
      this.keyBoardType = 1;
      this.twinkle_stop();
      this.$emit("cancel", {value: this.plateStr});
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style  scoped>
.panelText {
  display: inline-block;
  vertical-align: bottom;
  width: 40px;
  margin: 2px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.panelText.text {
  width: 178px;
}
.vehicle-panel {
  width: 400px;
  /* position: fixed; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 2100;
  background: #fff;
  padding: 0 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  z-index: 1000;
  /* transform: translateX(-50%); */
}
.vehicle-panel-row {
  padding-top: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.vehicle-panel-row-last {
  padding: 3px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mod04 {
  width: 82%;
  display: flex;
  flex-direction: column;
}
.mod04-row {
  display: flex;
  flex-direction: row;
}
.vehicle-panel-row-button {
  background-color: #fff;
  margin: 2px;
  padding: 2px;
  width: 32px;
  height: 34px;
  text-align: center;
  line-height: 31px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}
.vehicle-panel-row-button2 {
  background-color: #ccc;
  margin: 2px;
  padding: 2px;
  width: 50px;
  height: 30px;
  text-align: center;
  line-height: 27px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}
.vehicle-panel-row-button3 {
  margin: 2px;
  padding: 2px;
  width: 50px;
  height: 34px;
  text-align: center;
  line-height: 31px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}
.vehicle-panel-row-button-number {
  background-color: #eee;
}
.vehicle-panel-row-button-last {
  width: 32px;
  height: 32px;
  line-height: 34px;
}
.vehicle-hover {
  background-color: #ccc;
}
.vehicle-panel-row-button-img {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0f4ba1;
}
.vehicle-en-button-delete {
  color: #fff;
}
.vehicle-panel-ok {
  background-color: #0f4ba1;
  color: #fff;
  width: 60px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.top-button {
  width: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  cursor: pointer;
}
.row-btn {
  background-color: #f8f8f8;
}
.finish {
  color: #3296fa;
}
.mod04 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
